import { Dictionary } from "@/lib/Dictionary.type";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";

import DistributionCenter from "./distribution-center.model";

export default class DistributionCenterRepository extends BasicRepository<DistributionCenter> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<DistributionCenter>,
    responseParser: ApiCollectionResponseParserService<DistributionCenter>
  ) {
    super("distribution_centers", api, objectBuilder, responseParser);
  }

  protected prepareData(
    item: DistributionCenter
  ): Dictionary<string | number | boolean> {
    const data: Dictionary<string | number | boolean> = {
      id: item.id,
      name: item.name,
      code: item.code,
      email: item.email,
      active: item.isActive,
      boxParametersRequired: item.isBoxParametersRequired,
      sendNotificationCopy: item.shouldSendNotificationCopy,
    };

    if (item.serialNumber !== undefined) {
      data.serialNumber = item.serialNumber;
    }

    return data;
  }
}
